import React from 'react';
import { Size } from '../../../styles/theme.mjs';
import { StyledMediaCardContainer, StyledMediaCardDuration, StyledMediaCardImageContainer, StyledMediaCardImage, StyledIconButton, StyledTextContainer, StyledMediaCardHeading, StyledDate } from './SmallMediaCard.styles.mjs';
import { useTheme } from 'styled-components';

const SmallMediaCard = ({ durationTime, thumbnail, heading, fullWidth = false, href, updatedAt, onClick, className }) => {
    const theme = useTheme();
    return (React.createElement(StyledMediaCardContainer, { fullWidth: fullWidth, href: href, onClick: onClick, className: className },
        Boolean(durationTime) && React.createElement(StyledMediaCardDuration, { durationTime: durationTime }),
        React.createElement(StyledMediaCardImageContainer, null,
            React.createElement(StyledMediaCardImage, { alt: thumbnail.alt, src: thumbnail.src }),
            React.createElement(StyledIconButton, { iconType: durationTime ? 'play' : 'article', ariaLabel: durationTime ? 'play' : 'article', color: theme.colors.white })),
        React.createElement(StyledTextContainer, null,
            React.createElement(StyledMediaCardHeading, { tag: "h4" }, heading),
            updatedAt && (React.createElement(StyledDate, { size: Size.Micro, tag: "span", color: theme.colors.mutedTextColor }, updatedAt)))));
};

export { SmallMediaCard as default };
//# sourceMappingURL=SmallMediaCard.mjs.map
